// Banco de protocolos de uso dos óleos essenciais
import {
  FICHAS_SITUACOES,
  indicadoDaFicha,
  linhasDaSituacao,
} from './fichasSituacoes'

interface ProtocoloOleo {
  nome: string
  indicado: string
  aromatico?: string
  topico?: string
  interno?: string
  usoDireto?: string
  topicoGordura?: string
  topicoHormonal?: string
  topicoOndas?: string
  atencao?: string
}

// Instrução padrão de uso interno com água (padronizada em todo o sistema)
// Frequência e horário de cada óleo entram como complemento, sem alterar a regra base.
export function instrucaoInternaAgua(quando?: string, aviso?: string): string {
  const meio = quando ? `, ${quando.replace(/^,\s*/, '')}` : ''
  const base = `Ingerir: pingue 1 gota em uma colher e tome com água${meio}. Se preferir, use uma cápsula vegetal.`
  return aviso ? `${base} ${aviso}` : base
}

export const PROTOCOLOS_OLEOS: Record<string, ProtocoloOleo> = {
  'Lavanda': {
    nome: 'LAVANDA',
    indicado: 'sono, ansiedade, estresse, pressão alta, pele sensível.',
    aromatico: 'inalar 1 gota nas mãos antes de dormir ou sempre que sentir desconforto emocional.',
    topico: 'diluir 1 gota em 10 gotas de óleo de coco fracionado. Aplicar no peito, nuca, pulsos e/ou sola dos pés.',
    interno: '1 gota sublingual antes de dormir em casos de insônia ou tensão intensa. Deixar 1 minuto sob a língua e engolir.',
    atencao: 'pode aplicar 1 gota pura em cortes leves para estancar sangramento.',
  },
  'Hortelã-Pimenta': {
    nome: 'HORTELÃ-PIMENTA',
    indicado: 'energia, foco, dor de cabeça, desconforto digestivo, febre, problemas respiratórios.',
    aromatico: 'inalar 1 gota nas mãos para aumentar concentração, energia e disposição.',
    topico: 'diluir 1 gota em 10 gotas de óleo de coco fracionado. Aplicar na área afetada para dores ou na sola dos pés para febre.',
    interno: instrucaoInternaAgua('para desconforto digestivo'),
    atencao: 'não usar em hipertensos, gestantes, epiléticos ou lactantes.',
  },
  'Limão Siciliano': {
    nome: 'LIMÃO SICILIANO',
    indicado: 'detox, clareza mental, imunidade, limpeza linfática, foco.',
    aromatico: 'inalar 1 gota para foco, clareza e energia.',
    interno: instrucaoInternaAgua(
      'após o café da manhã, 2 a 3 vezes ao dia durante 7 dias para imunidade',
      'Usar garrafa de vidro, nunca plástico.'
    ),
    atencao: 'não aplicar na pele antes de exposição ao sol — causa manchas.',
  },
  'Olíbano': {
    nome: 'OLÍBANO',
    indicado: 'memória, inflamação, infecção, equilíbrio emocional, pele.',
    interno: '1 gota sublingual 2 a 3 vezes ao dia após as refeições. Potencializa quando usado junto com Copaíba.',
    topico: 'diluir 1 gota em 10 gotas de óleo de coco fracionado. Aplicar na área afetada ou em manchas na pele.',
  },
  'Copaíba': {
    nome: 'COPAÍBA',
    indicado: 'inflamação, dores crônicas, ansiedade, depressão, sistema nervoso.',
    interno: '1 gota sublingual 2 a 3 vezes ao dia após as refeições. Deixar 1 minuto sob a língua e engolir. Potencializa quando usado junto com Olíbano.',
    topico: 'diluir 1 gota em 10 gotas de óleo de coco fracionado. Aplicar na área afetada.',
  },
  'Tangerina': {
    nome: 'TANGERINA',
    indicado: 'alegria, leveza, ansiedade, sono, imunidade, equilíbrio emocional.',
    aromatico: 'inalar 1 gota para sentir alegria e calma.',
    interno: `${instrucaoInternaAgua('após o jantar para uma noite repousante')} ${instrucaoInternaAgua('2 a 3 vezes ao dia para imunidade')}`,
    atencao: 'não aplicar na pele antes de exposição ao sol — causa manchas.',
  },
  'Melaleuca': {
    nome: 'MELALEUCA',
    indicado: 'pele sensível, acne, fungos, infecções, imunidade.',
    topico: 'diluir 1 gota em 10 gotas de óleo de coco fracionado. Aplicar na área afetada.',
    interno: instrucaoInternaAgua(
      '3 vezes ao dia por até 10 dias para inflamações e infecções'
    ),
    usoDireto: '1 gota pura sobre fungo de unha ou acne.',
  },
  'Mix para Estabilidade': {
    nome: 'MIX PARA ATERRAMENTO (Balance)',
    indicado: 'ansiedade, medo, raiva, estagnação, equilíbrio emocional.',
    topico: 'aplicar 1 a 2 gotas diretamente na nuca, área do coração ou pulsos. Já contém óleo de coco fracionado na fórmula. Se preferir diluir, usar a proporção de 1 gota de Balance para 5 gotas de óleo de coco fracionado.',
    atencao: 'nunca ingerir.',
  },
  'Mix para Aterramento': {
    nome: 'MIX PARA ATERRAMENTO (Balance)',
    indicado: 'ansiedade, medo, raiva, estagnação, equilíbrio emocional.',
    topico: 'aplicar 1 a 2 gotas diretamente na nuca, área do coração ou pulsos. Já contém óleo de coco fracionado na fórmula. Se preferir diluir, usar a proporção de 1 gota de Balance para 5 gotas de óleo de coco fracionado.',
    atencao: 'nunca ingerir.',
  },
  'Mix Respiratório': {
    nome: 'MIX RESPIRATÓRIO (Breathe)',
    indicado: 'problemas respiratórios, ansiedade, tristeza.',
    topico: 'diluir 1 gota em 10 gotas de óleo de coco fracionado. Aplicar na garganta, peito ou costas.',
    aromatico: 'inalar 1 gota 2 a 3 vezes ao dia.',
    atencao: 'nunca ingerir.',
  },
  'Mix para Tensão e Dores': {
    nome: 'MIX CALMANTE (Deep Blue)',
    indicado: 'dores musculares, tensão, inflamações, dores nas articulações.',
    topico: 'diluir 1 gota em 10 gotas de óleo de coco fracionado. Aplicar na área afetada. Para dor de cabeça e enxaqueca, aplicar nas têmporas, nuca e ombros.',
    atencao: 'nunca ingerir. Nunca aplicar em feridas abertas.',
  },
  'Mix Imunidade': {
    nome: 'MIX DE PROTEÇÃO (On Guard)',
    indicado: 'imunidade, proteção, infecções, energia vital, resfriado, gripe.',
    interno: instrucaoInternaAgua(
      'após a refeição, 1 vez ao dia para imunidade ou 3 vezes ao dia por 7 dias para infecções'
    ),
    topico: 'diluir em 10 a 20 gotas de óleo de coco fracionado. Aplicar na sola dos pés, preferencialmente em áreas fora do sol, pois contém laranja e pode manchar a pele.',
    aromatico: 'somente no difusor. Nunca inalar puro nas mãos pois contém canela e pode irritar as narinas.',
  },
  'Mix Digestivo': {
    nome: 'MIX DIGESTIVO (Zengest)',
    indicado: 'intestino irregular, gases, refluxo, constipação, diarreia, cólicas, náusea.',
    interno: instrucaoInternaAgua('2 a 3 vezes ao dia após as refeições'),
    topico: 'diluir 1 gota em 10 gotas de óleo de coco fracionado. Aplicar na área do abdômen.',
  },
  'Mix Metabólico': {
    nome: 'MIX METABÓLICO (Meta PWR)',
    indicado: 'metabolismo, emagrecimento, gordura localizada, controle de apetite, energia.',
    interno: instrucaoInternaAgua(
      '30 minutos antes do café da manhã e do almoço e no final da tarde',
      'Usar garrafa de vidro — nunca plástico.'
    ),
    topicoGordura: 'diluir 1 gota em 10 gotas de óleo de coco fracionado. Aplicar com massagem circular nas regiões de gordura localizada como abdômen, flancos e coxas. A combinação de toranja, limão, hortelã-pimenta, gengibre e canela estimula a circulação local, aquece os tecidos e auxilia na drenagem e estímulo metabólico da região. Massagear por 2 a 3 minutos até absorver.',
    atencao: 'contém óleos cítricos. Não aplicar na pele antes de exposição ao sol.',
  },
  'Mix Mensal Feminino': {
    nome: 'MIX MENSAL FEMININO (ClaryCalm)',
    indicado: 'TPM, cólicas, menopausa, desequilíbrio hormonal, ondas de calor, irritabilidade, ansiedade feminina.',
    aromatico: 'aplicar nas palmas das mãos, espalhar e inalar por 1 minuto para equilibrar as emoções.',
    topico: 'aplicar diretamente no abdômen inferior com massagem suave durante a TPM e cólicas. Recomenda-se diluir com Óleo de Coco Fracionado dōTERRA para minimizar qualquer sensibilidade na pele. Aplique o óleo de coco fracionado no local após o ClaryCalm.',
    topicoHormonal: 'aplicar na nuca, têmporas, pulsos, tornozelos e sola dos pés, 2 a 3 vezes ao dia.',
    topicoOndas: 'aplicar na nuca e pulsos ao sentir o calor para efeito refrescante e calmante.',
    atencao: 'pode ser usado diariamente ao longo do mês, não apenas durante o ciclo. Já vem em frasco roll-on. Não usar durante a gravidez sem orientação médica.',
  },
}

// Classificação dos óleos por período do dia
// Ordem específica solicitada: Hortelã-Pimenta → Mix Metabólico → Limão Siciliano → Olíbano → Copaíba → Mix Imunidade (On Guard)
const OLEOS_MANHA = [
  'Hortelã-Pimenta',
  'Mix Metabólico',
  'Limão Siciliano',
  'Olíbano',
  'Copaíba',
  'Mix Imunidade',
]

const OLEOS_DIA = [
  'Mix para Estabilidade',
  'Mix para Aterramento',
  'Tangerina',
  'Mix Respiratório',
  'Mix Metabólico', // segunda dose
  'Copaíba', // segunda dose
  'Olíbano', // segunda dose
  'Limão Siciliano', // quando houver conflito com Meta PWR, uso aromático no dia
]

const OLEOS_NOITE = [
  'Lavanda',
  'Tangerina',
  'Mix para Estabilidade',
  'Mix para Aterramento',
  'Copaíba',
  'Mix Mensal Feminino',
  'Mix Digestivo',
]

// Instruções específicas por óleo e período
export const INSTRUCOES_ROTINA: Record<string, { manha?: string; dia?: string; noite?: string }> = {
  'Hortelã-Pimenta': {
    manha: 'inalar 1 gota para energia e foco ao acordar.',
  },
  'Limão Siciliano': {
    manha: `${instrucaoInternaAgua('após o café da manhã')} Usar garrafa de vidro, nunca plástico.`,
    dia: 'inalar 1 gota para clareza mental e leveza.',
  },
  'Mix Metabólico': {
    manha: `${instrucaoInternaAgua('30 minutos antes do café da manhã')} Usar garrafa de vidro — nunca plástico.`,
    dia: `${instrucaoInternaAgua('30 minutos antes do almoço e no final da tarde')} Usar garrafa de vidro — nunca plástico.`,
  },
  'Mix Imunidade': {
    manha: instrucaoInternaAgua('após o café da manhã'),
  },
  'Olíbano': {
    manha: '1 gota sublingual após o café da manhã.',
    dia: '1 gota sublingual após o almoço.',
  },
  'Copaíba': {
    manha: '1 gota sublingual após o café da manhã.',
    dia: '1 gota sublingual após o almoço.',
    noite: '1 gota sublingual após o jantar.',
  },
  'Mix para Estabilidade': {
    dia: 'aplicar na nuca ou pulsos sempre que sentir ansiedade ou estresse.',
    noite: 'aplicar na nuca e sola dos pés antes de dormir.',
  },
  'Mix para Aterramento': {
    dia: 'aplicar na nuca ou pulsos sempre que sentir ansiedade ou estresse.',
    noite: 'aplicar na nuca e sola dos pés antes de dormir.',
  },
  'Tangerina': {
    dia: 'inalar 1 gota para leveza e alegria.',
    noite: '1 gota após o jantar para uma noite repousante.',
  },
  'Mix Respiratório': {
    dia: 'inalar ou aplicar no peito em momentos de tensão.',
  },
  'Lavanda': {
    noite: 'inalar 1 gota ou aplicar no peito, nuca e pulsos antes de dormir.',
  },
  'Mix Mensal Feminino': {
    noite: 'aplicar no abdômen ou pulsos à noite.',
  },
  'Mix Digestivo': {
    noite: instrucaoInternaAgua('após o jantar, se necessário'),
  },
}

// Gerar protocolo completo formatado para WhatsApp
export function gerarProtocoloCompleto(oleosIndicados: string[]): string {
  let texto = ''

  oleosIndicados.forEach(oleo => {
    // Ficha por situação (Etapa 1): mesma apresentação da aba
    const ficha = FICHAS_SITUACOES[oleo]
    if (ficha) {
      const linhas: string[] = [`*${PROTOCOLOS_OLEOS[oleo]?.nome || oleo}*`]
      linhas.push(`*Indicado:* ${indicadoDaFicha(ficha)}`)
      if (ficha.comoAplicar) {
        linhas.push(`*Como aplicar:* ${ficha.comoAplicar}`)
      }
      ficha.situacoes.forEach(situacao => {
        const itens = linhasDaSituacao(ficha, situacao)
        if (itens.length === 0) return
        linhas.push(`*${situacao.situacao}:*`)
        itens.forEach(item => {
          const achado = item.match(/^([^:]{1,40}):\s*(.+)$/)
          linhas.push(achado ? `*${achado[1]}:* ${achado[2]}` : item)
        })
      })
      if (ficha.atencao) linhas.push(`*Atenção:* ${ficha.atencao}`)
      texto += `${linhas.join('\n')}\n\n`
      return
    }

    const protocolo = PROTOCOLOS_OLEOS[oleo]
    if (!protocolo) return

    texto += `*${protocolo.nome}*\n`
    texto += `*Indicado:* ${protocolo.indicado}\n`

    if (protocolo.aromatico) {
      texto += `*Aromático:* ${protocolo.aromatico}\n`
    }

    if (protocolo.topico) {
      texto += `*Tópico:* ${protocolo.topico}\n`
    }

    if (protocolo.topicoGordura) {
      texto += `*Tópico para gordura localizada:* ${protocolo.topicoGordura}\n`
    }

    if (protocolo.topicoHormonal) {
      texto += `*Tópico para equilíbrio hormonal:* ${protocolo.topicoHormonal}\n`
    }

    if (protocolo.topicoOndas) {
      texto += `*Tópico para ondas de calor:* ${protocolo.topicoOndas}\n`
    }

    if (protocolo.interno) {
      texto += `*Interno:* ${protocolo.interno}\n`
    }

    if (protocolo.usoDireto) {
      texto += `*Uso direto:* ${protocolo.usoDireto}\n`
    }

    if (protocolo.atencao) {
      texto += `*Atenção:* ${protocolo.atencao}\n`
    }

    texto += '\n'
  })

  return texto
}

// Gerar rotina diária formatada para WhatsApp
export function gerarRotinaDiaria(oleosIndicados: string[]): string {
  let texto = '*ROTINA DIÁRIA COM SEUS ÓLEOS ESSENCIAIS*\n\n'

  // Detectar conflito Limão Siciliano x Mix Metabólico (Meta PWR já contém limão)
  const temMetaPWR = oleosIndicados.includes('Mix Metabólico')
  const temLimao = oleosIndicados.includes('Limão Siciliano')
  const conflitoLimaoMetaPWR = temMetaPWR && temLimao

  // MANHÃ — mantém ordem definida em OLEOS_MANHA; se houver conflito, remover Limão da manhã
  const oleosManha = OLEOS_MANHA.filter(oleo => {
    if (!oleosIndicados.includes(oleo)) return false
    if (conflitoLimaoMetaPWR && oleo === 'Limão Siciliano') return false
    return true
  })
  if (oleosManha.length > 0) {
    texto += '*MANHÃ — Energia, foco e proteção*\n'
    oleosManha.forEach(oleo => {
      const instrucao = INSTRUCOES_ROTINA[oleo]?.manha
      if (instrucao) {
        const nomeExibicao = PROTOCOLOS_OLEOS[oleo]?.nome || oleo
        texto += `- ${nomeExibicao} → ${instrucao}\n`
      }
    })
    texto += '\n'
  }

  // DIA — se houver conflito, incluir Limão Siciliano aromático no dia
  const oleosDia = OLEOS_DIA.filter(oleo => {
    if (!oleosIndicados.includes(oleo)) return false
    // Limão Siciliano no DIA aparece apenas quando há conflito com Meta PWR
    if (oleo === 'Limão Siciliano' && !conflitoLimaoMetaPWR) return false
    return true
  })
  if (oleosDia.length > 0) {
    texto += '*DIA — Equilíbrio emocional e suporte contínuo*\n'
    oleosDia.forEach(oleo => {
      const instrucao = INSTRUCOES_ROTINA[oleo]?.dia
      if (instrucao) {
        const nomeExibicao = PROTOCOLOS_OLEOS[oleo]?.nome || oleo
        texto += `- ${nomeExibicao} → ${instrucao}\n`
      }
    })
    texto += '\n'
  }

  // NOITE
  const oleosNoite = OLEOS_NOITE.filter(oleo => oleosIndicados.includes(oleo))
  if (oleosNoite.length > 0) {
    texto += '*NOITE — Descanso, relaxamento e regeneração*\n'
    oleosNoite.forEach(oleo => {
      const instrucao = INSTRUCOES_ROTINA[oleo]?.noite
      if (instrucao) {
        const nomeExibicao = PROTOCOLOS_OLEOS[oleo]?.nome || oleo
        texto += `- ${nomeExibicao} → ${instrucao}\n`
      }
    })
    texto += '\n'
  }

  texto += '*Observação:* cada pessoa é única. Respeite como seu corpo reage a cada óleo e ajuste conforme sua necessidade. Na dúvida, entre em contato para orientação personalizada.'

  return texto
}

// Gerar texto completo (protocolo + rotina) para WhatsApp
export function gerarTextoCompletoWhatsApp(oleosIndicados: string[], nomeCliente?: string): string {
  let texto = ''
  
  // Adicionar cabeçalho com nome da cliente
  if (nomeCliente) {
    texto += `*${nomeCliente.trim()}*\n`
    texto += '*PROTOCOLO DE USO — ÓLEOS ESSENCIAIS*\n\n'
  }
  
  const protocolo = gerarProtocoloCompleto(oleosIndicados)
  const rotina = gerarRotinaDiaria(oleosIndicados)

  return `${texto}${protocolo}\n${rotina}`
}
